import AppComments from './AppComments';

export default AppComments;
